import type { Driver, PopoverDOM } from 'driver.js'

/**
 * Recompute highlight and popover positions across multiple frames.
 * Needed when layout shifts after the tour step is highlighted.
 */
export function scheduleDriverLayoutSync(driver: Driver, frameCount = 5): void {
  let remaining = frameCount
  const tick = () => {
    if (!driver.isActive()) return
    driver.refresh()
    remaining -= 1
    if (remaining > 0) requestAnimationFrame(tick)
  }
  requestAnimationFrame(tick)
}

/** driver.js replaces literal `{{current}}` / `{{total}}` — keep those substrings out of vue-i18n messages. */
export function addonTourProgressText(
  t: (key: string) => string,
  beforeKey = 'cpPackages.tour.progressLabelBefore',
  betweenKey = 'cpPackages.tour.progressLabelBetween',
): string {
  return `${t(beforeKey)} {{current}} ${t(betweenKey)} {{total}}`
}

/** Skip row appended to every popover footer. */
export function attachAddonTourSkipRow(
  popover: PopoverDOM,
  driver: Driver,
  skipLabel: string,
  onSkip: (d: Driver) => void,
): void {
  popover.footer.querySelector('.cp-tour-popover-skip-row')?.remove()
  const row = document.createElement('div')
  row.className = 'cp-tour-popover-skip-row'
  const btn = document.createElement('button')
  btn.type = 'button'
  btn.className = 'cp-tour-skip-btn'
  btn.textContent = skipLabel
  btn.addEventListener('click', (e) => {
    e.preventDefault()
    e.stopPropagation()
    onSkip(driver)
  })
  row.appendChild(btn)
  popover.footer.appendChild(row)
}
